<form [formGroup]="emailTemplateForm">
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label for="templateName" class="control-label required">{{ 'i18n.domain.export-configuration.email-templates.email-form.form-fields.template-name' | translate }}</label>
      <input id="templateName" type="text" class="form-control" formControlName="templateName" />
      <app-error-messages [control]="emailTemplateForm.get('templateName')"></app-error-messages>
    </div>
    <div class="form-group col-md-4">
      <label for="outputEmailAccountId"
        class="control-label required">{{'i18n.base.shared.email-form.form-fields.output-email-account'
        | translate }}</label>
      <ejs-dropdownlist id="outputEmailAccountId" formControlName="emailAccountId" [dataSource]="outputEmailAccounts"
        [fields]="outputEmailAccountFields" [allowFiltering]="true">
      </ejs-dropdownlist>
      <app-error-messages [control]="emailTemplateForm.get('emailAccountId')"></app-error-messages>
    </div>
  </div>
</form>
<app-email-form [emailForm]="emailTemplateForm" [showLoadFromTemplateButton]="false" [showOutputEmailAccountField]="false"></app-email-form>
